<template>
    <v-container fluid style="width: 50%;">
        <div v-if="loading===false">
          <v-card flat>
            <v-card-title>Host yearly grading and booking value information</v-card-title>
          </v-card>
          <v-card-text>
            <div>The sales value is calculated for each year, for all accommodations that this host owns and for all bookings that have stays that start in the year that is being calculated. Calculation considers only bookings directly connected to the host.</div>
            <div class="py-2 mt-4" style="font-size: 1.25rem; font-weight: 500;">Host grade</div>
            <div class="mt-4">The host is graded using the booking value and this table below:</div>
            <v-card outlined class="mt-4" v-if="data && data.host_grades" style="width: 100%;">
                <v-simple-table dense>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-left py-1" width="200">Grade</th>
                                <th class="text-left py-1">From amount</th>
                                <th class="text-left py-1">Until amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="code in data.host_grades" :key="code.host_grade">
                                <td class="py-1">{{ code.host_grade }}</td>
                                <td class="py-1">{{ code.value_1 }}</td>
                                <td class="py-1">{{ code.value_2 }}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card>
          </v-card-text>
        </div>
        <div v-else class="d-flex flex-column align-center justify-center" style="min-height: 300px;">
            <v-progress-circular
                indeterminate
                color="primary"
                size="64"
            ></v-progress-circular>
            <div class="text-h6 font-weight-bold mt-4">
                Loading, please wait...
            </div>
        </div>
    </v-container>
</template>

<script>
export default {
    data() { 
        return {
            loading: true,
            data: {},
        }
    },
    mounted() {
        this.$axios
            .post("ares/json/ares/eign/getCalculationInfo.p", {
                header: {
                    token: this.$session.get("ARES"),
                    clientSessionId: this.$session.id(),                  
                    request: "getCalculationInfo",
                },
                getCalculationInfo: {}
            })
            .then(res => {
                if (res.data.error) {
                    console.log(res.data.error)
                    this.loading = false;
                } else {                    
                    this.data = res.data.getCalculationInfo;                
                    this.loading = false;
                }
            });      
    },
    methods: {
    }
}
</script>

<style scoped>
.flex {
    display: flex;
    flex-direction: row;
    align-items: center;
}
</style>